import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import ForgotPassword from '../components/Forgotpassword'

const SignUpPage = () => {
    return (
        <>
        <ScrollToTop/>
        <ForgotPassword />
        </>
    )
}

export default SignUpPage
